module.exports = __webpack_public_path__ + "img/weixin1.c33b9768.png";